import { Modal } from 'antd'

export const Popup = (props: any) => {
  const { onCancel, content, title, closable, visibility, width, className, destroyOnClose } = props

  return (
    <Modal
      centered
      maskClosable={false}
      closable={closable}
      wrapClassName={className}
      open={visibility}
      okButtonProps={{ className: 'ag-gray-button' }}
      cancelButtonProps={{ className: 'ag-gray-button-outline' }}
      title={title && title}
      footer={null}
      width={width}
      onCancel={onCancel}
      destroyOnClose={destroyOnClose}
    >
      {content}
    </Modal>
  )
}
